import {initParam} from "../setting/initParam";
import {
    calcExtendForOffsetLine, CalcPlaceFromDiagonalIntersectDiagonal, centeredLine, createDefaultMaterial,
    getMetaNumber,
    getOffsetsAfterRotation, InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    Line2,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec2, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";


export async function getF6(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const angleF6 = initParam.angles.f6

    const H = initParam.elementData.f2.sizeBoard.l - initParam.gash.simple - initParam.gash.simple
    const offsetW = initParam.maps.f4.point[0] + initParam.elementData.f5.sizeBoard.w
    const startPoint: Vec2 = [offsetW, 0]
    const placeInfo = CalcPlaceFromDiagonalIntersectDiagonal(initParam.maps.f3.diagonal, angleF6, startPoint)

    const line: Line2 = [startPoint, [placeInfo.w, placeInfo.h]]
    const extendL = calcExtendForOffsetLine(line, initParam.maps.f3.diagonal, sBoard.h)

    initParam.maps.f6.point = [placeInfo.w, placeInfo.h]

    // const resultCalcPlaceFromDiagonalL2 = CalcPlaceFromDiagonalY(s.a, H)
    //
    // const placeInfo = resultCalcPlaceFromDiagonalL2.l
    //
    // initParam.elementData.f3.sizeBoard.l = placeInfo

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l:  placeInfo.l},
        cuts: [],
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle: 90 - angleF6,
            angleReturn: s.a + angleF6,
            variant: JoinVariant.DoubleAngle,
        },
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle:  angleF6,
            variant: JoinVariant.DoubleAngle
        },
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'F6'
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const realSeg = centeredLine(initParam.maps.f1.lineCut, s.l)

    const metaJEOffset1End = getMetaNumber(meta.modify, "joinEnd", "offset1")
    const metaJEOffset2End = getMetaNumber(meta.modify, "joinEnd", "offset2")
    const metaJEOffsetStart = getMetaNumber(meta.modify, "joinStart", "offset")

    const line2:Line2 = [[meta.h, 0], [meta.h, meta.l - metaJEOffset2End]]
    const line1:Line2 = [[meta.h / 2, meta.l / 2],[meta.h / 2, meta.l]]
    const line3:Line2 = [[0, 0 + metaJEOffsetStart], [0, meta.l - metaJEOffset1End]]

    const p:Line2[] = [line1, line2, line3]

    const testOfset = getOffsetsAfterRotation(p, Math.PI / 2 + angleF6 * Math.PI / 180)

    for (let i = 0; i < realSeg.length; i++) {
        const x = realSeg[i][0]

        const z = s.h
            - initParam.gash.simple
            + initParam.elementData.f1.sizeBoard.h
            + meta.l / 2
            - testOfset.deltaBottom

        const yR = 0
            - initParam.elementData.f2.sizeBoard.w
            - testOfset.deltaLeft
            - offsetW

        const yL = 0
            + initParam.elementData.f2.sizeBoard.w
            + testOfset.deltaLeft
            + offsetW

        const posR:Vec3 = [x, z, yR]
        const posL:Vec3 = [x, z, yL]

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [Math.PI / 2 + angleF6 * Math.PI / 180, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardR)

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            // rotation: [0, 0, 0],
            rotation: [-Math.PI / 2 - angleF6 * Math.PI / 180, Math.PI, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardL)
    }

    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: "F6",
        group: locale['truss'][lang],
        count: (realSeg.length - 1) * 2,
    })

    return {rs: rs, spec: spec}
}
